import { createGlobalStyle } from 'styled-components';
import { device } from "../device";

import { Roboto300WOFF2,Roboto300WOFF,Roboto400WOFF2,Roboto400WOFF,Roboto500WOFF2,Roboto500WOFF } from '../../fonts'

export default createGlobalStyle`
:root {
    --light-gray1: #f7f7f7;
    --light-gray2: #ededed;
    --light-gray3: #dbdbdb;
    --light-gray4: #c7c7c7;

    --midle-gray1: #adadad;
    --midle-gray2: #5e5e5e;
    --midle-gray3: #383838;
    --midle-gray4: #919191;

    --dark-gray1: #303030;
    --dark-gray2: #242424;

    --dark: #3b3b3b;

    --brand: #181818;

    --green1: #5AE4AA;
    --green2: #1dcf8e;
    --green3: #00ad74;
}

@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: local('Roboto Light'), local('Roboto-Light'),
       url('${Roboto300WOFF2}') format('woff2'),
       url('${Roboto300WOFF}') format('woff');
}
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local('Roboto'), local('Roboto-Regular'),
       url('${Roboto400WOFF2}') format('woff2'),
       url('${Roboto400WOFF}') format('woff');
}
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: local('Roboto Medium'), local('Roboto-Medium'),
       url('${Roboto500WOFF2}') format('woff2'),
       url('${Roboto500WOFF}') format('woff');
}
*,
*::before,
*::after {
    box-sizing: border-box;
}
html {
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    -ms-overflow-style: scrollbar;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -ms-overflow-style: scrollbar;
}
article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
    display: block;
}
body {
    background-color: var(--light-gray2);
    color: var(--brand);
    display: flex;
    flex-direction: column;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    margin: 0;
    text-align: left;
    overflow-x: hidden;
    text-rendering: optimizeLegibility;
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
    -webkit-overflow-scrolling: touch;
    @media ${device.lg} {
        font-size: 18px;
    }
}
::selection {
    color: var(--brand);
    background: var(--green1);
}
a {
    color: var(--brand);
    display: inline-block;
    text-decoration: none;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
    -webkit-tap-highlight-color: hsla(0, 0%, 0%, 0);
    -webkit-tap-highlight-color: transparent;
    &:hover {
        color: var(--green1);
        text-decoration: none;
    }
    &.underline {
        text-decoration: underline;
        &:hover,
        &:focus {
            color: var(--brand);
            text-decoration: underline;
        }
    }
}
img {
    display: inline-block;
    vertical-align: middle;
    border-style: none;
    max-width: 100%;
    &[data-src],
    &[data-srcset] {
        min-height: 1px;
    }
    &:not([src]) {
        visibility: hidden;
    }
}

svg:not(:root) {
    overflow: hidden;
}
button {
    font: inherit;
}
.ReactModal__Body--open,
.ReactModal__Html--open {
    overflow: hidden;
}
.hide-desktop {
    @media ${device.lg} {
        display: none;
    }
}
.hide-mob {
    display: none;
    @media ${device.lg} {
        display: block;
    }
}
.ajax-spinner {
    .inner,
    .outer {
        transform-origin: 50% 50%;
    }
    .inner {
        animation: spin .6s infinite linear;
    }
    .outer {
        animation: spin 1.5s infinite linear;
        animation-direction: reverse;
    }
}
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(359deg);
    }
}
`;
